// extracted by css-extract-rspack-plugin
export default {"priceStats":"_af6ad396","negativeLeftMargin":"_4fdb301c","source":"_63ba9827"};